import React from 'react'
import {connect} from 'react-redux'
import {makeSelectTopic, selectNthLeafFromCurrent} from '../../../redux/modules/topic'
import {selectNthFromCurrentIdInFlatmap} from '../../../redux/modules/topicFlatMap'
import {toJS} from '../../../util/ToJS'
import {fetchTopic} from '../../../redux/modules/entities'
import RelatedLessons from '../components/RelatedLessons'

class VisibleRelatedLessons extends React.PureComponent {
  componentDidMount() {
    const {nextLeafId, prevLeafId, nextLeaf, prevLeaf, nearLeaf1Id, nearLeaf2Id, nearLeaf1, nearLeaf2, getTopic} = this.props
    if (!nextLeaf) {
      getTopic(nextLeafId)
    }
    if (!prevLeaf) {
      getTopic(prevLeafId)
    }
    if (!nearLeaf1) {
      getTopic(nearLeaf1Id)
    }
    if (!nearLeaf2) {
      getTopic(nearLeaf2Id)
    }
  }
  render() {
    //const props = this.props
    //const {nextLeafId, prevLeafId} = props
    return (
      <RelatedLessons {...this.props} />
    )
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const topic = selectTopic(state)
    const nextLeafId = selectNthFromCurrentIdInFlatmap(state, 1)
    const prevLeafId = selectNthFromCurrentIdInFlatmap(state, -1)
    const nextLeaf = selectNthLeafFromCurrent(state, 1)
    const prevLeaf = selectNthLeafFromCurrent(state, -1)
    //get two other nearby leaves
    const nearLeaf1Id = selectNthFromCurrentIdInFlatmap(state, 2)
    const nearLeaf2Id = selectNthFromCurrentIdInFlatmap(state, -2)
    const nearLeaf1 = selectNthLeafFromCurrent(state, 2)
    const nearLeaf2 = selectNthLeafFromCurrent(state, -2)
    return {
      breadcrumbTopics: topic.get('breadcrumbs'),
      nextLeafId,
      prevLeafId,
      nextLeaf,
      prevLeaf,
      nearLeaf1Id,
      nearLeaf2Id,
      nearLeaf1,
      nearLeaf2
    }
  }
  return mapStateToProps
}
const mapDispatchToProps = (dispatch) => ({
  getTopic: (topicId) => dispatch(fetchTopic(topicId))
})

export default connect(makeMapStateToProps, mapDispatchToProps)(toJS(VisibleRelatedLessons))



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleRelatedLessons.js